import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { QidCompanyDocument } from "server/models"
import {
    StoreType,
    createFileName,
    getFileLogo,
    addModal,
    setDriveOutsideMode,
    setQidCompanyDocumentReloadList,
} from "client/store"
import {
    TableColumn,
    Link,
    Logo,
} from "client/components"

import FileEdit from "client/pages/drive/fileEdit"

const Columns = (companyEditAccess: boolean) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const documentLink = (document: QidCompanyDocument, linkContent: any) => (
        <Link
            href="/#"
            onClick={() => {
                dispatch(setDriveOutsideMode(true))
                dispatch(addModal({
                    key: "viewDocument",
                    content: <FileEdit fileId={document.fileId} />,
                    onClose: () => {
                        dispatch(setDriveOutsideMode(false))
                        dispatch(setQidCompanyDocumentReloadList(false))
                        setTimeout(() => {
                            dispatch(setQidCompanyDocumentReloadList(true))
                        }, 0)
                    },
                }))
            }}
        >
            {linkContent}
        </Link>
    )

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            formatter: (document: QidCompanyDocument) => document.file.id,
        },
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (document: QidCompanyDocument) => {
                const { file } = document
                return documentLink(
                    document,
                    <Logo table logo={getFileLogo(file, file.versions && file.versions[0])} />,
                )
            },
        },
        {
            field: "file",
            header: lang.file,
            cellMinWidth: "200px",
            formatter: (document: QidCompanyDocument) => documentLink(document, createFileName(document.file)),
        },
        // TODO: tempoparily disabled
        /*
        {
            field: "tags",
            header: lang.tags,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
            formatter: (document: QidCompanyDocument) => {
                const tagIds: number[] = []
                if (document.file && document.file.tags) {
                    document.file.tags.forEach((tag) => {
                        tagIds.push(tag.tagId)
                    })
                }
                return (
                    <TagEditor
                        selectedIds={tagIds}
                        tableView
                        readOnly
                    />
                )
            },
        },
        */
    ]

    if (companyEditAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
